const $navigation = $('.navigation');
const $navToggle = $('.js-nav-toggle');
const $navToggleText = $('.js-nav-toggle-text');
const $navWrap = $('.js-nav-wrap');
const $navItems = $navWrap.find('.navigation__list > .navigation__item');

const navigation = {
  initialize() {
    if ($navigation.length) {
      this.createEvents();
    }
  },

  createEvents() {
    $navToggle.on('click', (e) => {
      e.preventDefault();
      const isOpen = $navToggle.hasClass('is-open');

      $navToggle.toggleClass('is-open', !isOpen);

      if (isOpen) {
        $navWrap.css('height', 0);
        $navToggleText.html('Menu');
      } else {
        this.openList();
        $navToggleText.html('Sluit');
      }
    });
  },

  openList() {
    this.changeListHeight($navItems);
  },

  changeListHeight($items) {
    const navHeight = this.getListHeight($items);
    $navWrap.css('height', navHeight);
  },

  getListHeight($items) {
    const innerWidth = $navWrap.find($items).toArray().reduce((accumulator, child) => (
      accumulator + $(child).innerHeight()
    ), 0);

    $navWrap.css('height', innerWidth);
  },
};

export default navigation;
